"use client";

import { useState, useEffect } from "react";
import { Box, Button, Typography, styled } from "@mui/material";

const ConsentBanner = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "#fff",
  borderTop: "1px solid #e0e0e0",
  padding: "16px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  zIndex: 9999,
  boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    textAlign: "center",
    gap: "12px",
  },
}));

const ConsentText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.text.primary,
  flex: 1,
}));

const ConsentButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  padding: "8px 24px",
  fontSize: "14px",
  fontWeight: 500,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies (client-side only)
    if (typeof window !== 'undefined') {
      const hasAcceptedCookies = localStorage.getItem("cookieConsent");
      if (!hasAcceptedCookies) {
        // Intentional: localStorage is client-only, so visibility must be
        // decided after mount to avoid an SSR hydration mismatch.
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsVisible(true);
      }
    }
  }, []);

  const handleAcceptCookies = () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem("cookieConsent", "accepted");
    }
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <ConsentBanner>
      <ConsentText>
        We use cookies to enhance your experience and analyze site usage. By continuing to use this site, you consent to our use of cookies.
      </ConsentText>
      <ConsentButton variant="contained" onClick={handleAcceptCookies}>
        Allow cookies
      </ConsentButton>
    </ConsentBanner>
  );
}